import ElementContent from '@/components/sections/builder/elements/body/video/content';
import ElementSetting from '@/components/sections/builder/elements/body/video/setting';
import { ElementDataType } from './types';
import { MonitorPlay } from 'lucide-react';

const defaultData: ElementDataType = {
  name: 'Video',
  contentName: 'Video',
  url: '',
  file: null,
  thumbnail: '',
  loop: false,
  autoplay: false,
  controls: true,
  mute: false,
  aspectRatio: '16/9',
  layout: 'full',
  mobileMinWidth: 720,
  isYoutubeVideo: false,
  youtubeVideoUrl: '',
  youtubeMobileVideo: '',
};

export const ElementPreviewIcon = MonitorPlay;

const Video = {
  type: 'video',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
};

export default Video;
